/* tslint:disable */
/* eslint-disable */
/**
 * OneAir.AdminPortal
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: v1
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { exists, mapValues } from '../runtime';
import {
    BrandAndMarketListItem,
    BrandAndMarketListItemFromJSON,
    BrandAndMarketListItemFromJSONTyped,
    BrandAndMarketListItemToJSON,
} from './';

/**
 * 
 * @export
 * @interface BCMBookingIdRemarkRuleListItem
 */
export interface BCMBookingIdRemarkRuleListItem {
    /**
     * 
     * @type {string}
     * @memberof BCMBookingIdRemarkRuleListItem
     */
    id?: string;
    /**
     * 
     * @type {boolean}
     * @memberof BCMBookingIdRemarkRuleListItem
     */
    disabled?: boolean;
    /**
     * 
     * @type {boolean}
     * @memberof BCMBookingIdRemarkRuleListItem
     */
    deleted?: boolean;
    /**
     * 
     * @type {string}
     * @memberof BCMBookingIdRemarkRuleListItem
     */
    description?: string | null;
    /**
     * 
     * @type {BrandAndMarketListItem}
     * @memberof BCMBookingIdRemarkRuleListItem
     */
    brandAndMarket?: BrandAndMarketListItem;
    /**
     * 
     * @type {boolean}
     * @memberof BCMBookingIdRemarkRuleListItem
     */
    allowEdit?: boolean;
}

export function BCMBookingIdRemarkRuleListItemFromJSON(json: any): BCMBookingIdRemarkRuleListItem {
    return BCMBookingIdRemarkRuleListItemFromJSONTyped(json, false);
}

export function BCMBookingIdRemarkRuleListItemFromJSONTyped(json: any, ignoreDiscriminator: boolean): BCMBookingIdRemarkRuleListItem {
    if ((json === undefined) || (json === null)) {
        return json;
    }
    return {
        
        'id': !exists(json, 'id') ? undefined : json['id'],
        'disabled': !exists(json, 'disabled') ? undefined : json['disabled'],
        'deleted': !exists(json, 'deleted') ? undefined : json['deleted'],
        'description': !exists(json, 'description') ? undefined : json['description'],
        'brandAndMarket': !exists(json, 'brandAndMarket') ? undefined : BrandAndMarketListItemFromJSON(json['brandAndMarket']),
        'allowEdit': !exists(json, 'allowEdit') ? undefined : json['allowEdit'],
    };
}

export function BCMBookingIdRemarkRuleListItemToJSON(value?: BCMBookingIdRemarkRuleListItem | null): any {
    if (value === undefined) {
        return undefined;
    }
    if (value === null) {
        return null;
    }
    return {
        
        'id': value.id,
        'disabled': value.disabled,
        'deleted': value.deleted,
        'description': value.description,
        'brandAndMarket': BrandAndMarketListItemToJSON(value.brandAndMarket),
        'allowEdit': value.allowEdit,
    };
}


